<template>
  <div class="shoppinglist-wrapper">
    <ul class="shoppinglist" v-if="!listEmpty">
      <li
        v-for="product in items"
        :key="product.nr"
        :class="{ 'not-available': !product.available }"
      >
        <div class="item-container">
          <router-link
          tabindex="-1"
          aria-hidden="true"
            :to="{
              name: 'product',
              params: { nr: product.nr, slug: product.slug },
              query: { list: sharelist }
            }"
            class="pic"
            :style="{
              'background-image':
                product.thumb && product.thumb.length > 0
                  ? 'url(' + product.thumb + ')'
                  : 'none'
            }"
            :title="`Produktabbildung: ${product.title}`"
            :aria-label="`Zum Produkt: ${product.title}`"
          ><span class="hidden">Zum Produkt {{ product.title }}</span></router-link>

          <div class="details">
            <h4 class="title-with-package-hint">
              <router-link
                :to="{
                  name: 'product',
                  params: { nr: product.nr, slug: product.slug },
                  query: { list: sharelist }
                }"
                ><small>{{ product.categories[0] }}</small
                ><span v-if="product.count > 1">{{ product.count }}x </span
                >{{ product.title }}<sup>3</sup></router-link
              >
            </h4>

            <div class="counter-container" v-if="!view">
              <button
                v-on:click.prevent="alterCount(product, -1)" :aria-label="`Menge verringern für ${product.title}`"
              >
                -
              </button>
              <div class="count">{{ product.count }}</div>
              <button v-on:click.prevent="alterCount(product, 1)" :aria-label="`Menge erhöhen für ${product.title}`">
                +
              </button>
            </div>
          </div>

          <div :class="{ meta: true, 'just-price': view }">
            <PriceLabel
              :price="parseFloat(product.price) * product.count"
              :priceApp="parseFloat(product.priceApp) * product.count"
              :productData="product"
              :inline="false"
            />
            <button
              v-if="!view"
              class="remove"
              v-on:click.prevent="removeItem(product)"
            >
              Entfernen
            </button>
          </div>
        </div>
        <em class="not-available"
          ><i class="icon-info circle" aria-hidden="true"></i>Im ausgewählten REWE Markt nicht
          verfügbar.</em
        >
      </li>

      <li class="sum">
        <div class="label">
          <h4>Gesamtpreis:</h4>
          <small
            >Alle Preisangaben inkl. MwSt.
          </small
          >
        </div>
        <div class="price">
          <div class="item">
            <small>Preis</small>
            <PriceLabel 
              :price="sum" 
              :inline="true" 
              :big="false" 
            />
            <div class="bonus" v-if="listContainsBonusProduct">
              <img src="/assets/images/bonus-badge-25euro.png" alt="25,00 € Bonus" />
            </div>
          </div>
          
        </div>
      </li>
    </ul>
    
    <div 
      v-if="announcement"
      class="visually-hidden"
      role="status"
      aria-live="polite">
      {{ announcement }}
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import debounce from "lodash.debounce";
import PriceLabel from "@/components/PriceLabel.vue";
export default {
  components: { PriceLabel },
  props: {
    items: {
      type: Array,
      required: true
    },
    view: Boolean,
    sharelist: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      market: false,
      products: [],
      announcement: null
    };
  },
  methods: {
    goToProduct(routeObj) {
      this.$router.push(routeObj);
    },
    updateData: debounce(function() {
      this.$store.dispatch("updateShoppinglistData");
    }, 500),
    removeItem(product) {
      this.$store.commit("REMOVE_SHOPPINGLIST_ITEM", product.nr);
      this.updateData();
    },
    alterCount(product, amount) {
      if (amount <= -1 && product.count <= 1) {
        // remove item
        this.removeItem(product);
      } else {
        // alter count
        this.$store.commit("UPDATE_SHOPPINGLIST_COUNT", {
          produktnummer: product.nr,
          count: product.count + amount
        });
        this.updateData();
      }
    },
    announce() {
      this.announcement = `Gesamtpreis: Alle Preisangaben inkl. MwSt., Preis EUR ${parseFloat(this.sum).toFixed(2).replace(".", ",")}`;
    }
  },
  computed: {
    sum() {
      let sum = 0;
      this.items.forEach(el => {
        sum += el.price * el.count;
      });
      return sum;
    },
    listEmpty() {
      return this.items.length === 0;
    },
    listContainsBonusProduct() {
      return this.items.some(el => el.bonusProdukt);
    }
  },
  watch: {
    sum() {
      this.announce();
    }
  }
};
</script>

<style lang="scss">
@import "./ShoppinglistItems";
</style>
